module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('google-map', {
    attrs: {
      "sharer": _vm.sharer,
      "show-lengend": _vm.showLegend,
      "map-style": "elevation",
      "show-sites": false,
      "legend": _vm.legend
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6604371c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps/TenancyExpiryMap.vue
// module id = 1531
// module chunks = 0